module.exports = __webpack_public_path__ + "static/img/pexels-danxavier-1212984.9f72fd3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/pexels-danxavier-1212984.webp
// module id = IblL
// module chunks = 0